module.exports = __webpack_public_path__ + "img/logo3.08a10d12.png";